Object.defineProperty(exports, "__esModule", {
    value: true
});
var _object_spread = require("@swc/helpers/_/_object_spread");
var require_logger = require('./logger.cjs');
var require_manifest = require('./manifest.cjs');
var require_load = require('./load.cjs');
var _module_federation_sdk = require("@module-federation/sdk");
//#region src/utils/preload.ts
function defaultPreloadArgs(preloadConfig) {
    return _object_spread._({
        resourceCategory: "sync",
        share: true,
        depsRemote: true,
        prefetchInterface: false
    }, preloadConfig);
}
function formatPreloadArgs(remotes, preloadArgs) {
    return preloadArgs.map((args)=>{
        var remoteInfo = require_manifest.matchRemote(remotes, args.nameOrAlias);
        require_logger.assert(remoteInfo, `Unable to preload ${args.nameOrAlias} as it is not included in ${!remoteInfo && (0, _module_federation_sdk.safeToString)({
            remoteInfo,
            remotes
        })}`);
        return {
            remote: remoteInfo,
            preloadConfig: defaultPreloadArgs(args)
        };
    });
}
function normalizePreloadExposes(exposes) {
    if (!exposes) return [];
    return exposes.map((expose)=>{
        if (expose === ".") return expose;
        if (expose.startsWith("./")) return expose.replace("./", "");
        return expose;
    });
}
function preloadAssets(remoteInfo, host, assets) {
    var useLinkPreload = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var cssAssets = assets.cssAssets, jsAssetsWithoutEntry = assets.jsAssetsWithoutEntry, entryAssets = assets.entryAssets;
    if (host.options.inBrowser) {
        entryAssets.forEach((asset)=>{
            var moduleInfo = asset.moduleInfo;
            var module = host.moduleCache.get(remoteInfo.name);
            if (module) require_load.getRemoteEntry({
                origin: host,
                remoteInfo: moduleInfo,
                remoteEntryExports: module.remoteEntryExports
            });
            else require_load.getRemoteEntry({
                origin: host,
                remoteInfo: moduleInfo,
                remoteEntryExports: void 0
            });
        });
        if (useLinkPreload) {
            var defaultAttrs = {
                rel: "preload",
                as: "style"
            };
            cssAssets.forEach((cssUrl)=>{
                var _ref = (0, _module_federation_sdk.createLink)({
                    url: cssUrl,
                    cb: ()=>{},
                    attrs: defaultAttrs,
                    createLinkHook: (url, attrs)=>{
                        var res = host.loaderHook.lifecycle.createLink.emit({
                            url,
                            attrs,
                            remoteInfo
                        });
                        if (res instanceof HTMLLinkElement) return res;
                    }
                }), cssEl = _ref.link, needAttach = _ref.needAttach;
                needAttach && document.head.appendChild(cssEl);
            });
        } else {
            var defaultAttrs1 = {
                rel: "stylesheet",
                type: "text/css"
            };
            cssAssets.forEach((cssUrl)=>{
                var _ref = (0, _module_federation_sdk.createLink)({
                    url: cssUrl,
                    cb: ()=>{},
                    attrs: defaultAttrs1,
                    createLinkHook: (url, attrs)=>{
                        var res = host.loaderHook.lifecycle.createLink.emit({
                            url,
                            attrs,
                            remoteInfo
                        });
                        if (res instanceof HTMLLinkElement) return res;
                    },
                    needDeleteLink: false
                }), cssEl = _ref.link, needAttach = _ref.needAttach;
                needAttach && document.head.appendChild(cssEl);
            });
        }
        if (useLinkPreload) {
            var defaultAttrs2 = {
                rel: "preload",
                as: "script"
            };
            jsAssetsWithoutEntry.forEach((jsUrl)=>{
                var _ref = (0, _module_federation_sdk.createLink)({
                    url: jsUrl,
                    cb: ()=>{},
                    attrs: defaultAttrs2,
                    createLinkHook: (url, attrs)=>{
                        var res = host.loaderHook.lifecycle.createLink.emit({
                            url,
                            attrs,
                            remoteInfo
                        });
                        if (res instanceof HTMLLinkElement) return res;
                    }
                }), linkEl = _ref.link, needAttach = _ref.needAttach;
                needAttach && document.head.appendChild(linkEl);
            });
        } else {
            var defaultAttrs3 = {
                fetchpriority: "high",
                type: (remoteInfo === null || remoteInfo === void 0 ? void 0 : remoteInfo.type) === "module" ? "module" : "text/javascript"
            };
            jsAssetsWithoutEntry.forEach((jsUrl)=>{
                var _ref = (0, _module_federation_sdk.createScript)({
                    url: jsUrl,
                    cb: ()=>{},
                    attrs: defaultAttrs3,
                    createScriptHook: (url, attrs)=>{
                        var res = host.loaderHook.lifecycle.createScript.emit({
                            url,
                            attrs,
                            remoteInfo
                        });
                        if (res instanceof HTMLScriptElement) return res;
                    },
                    needDeleteScript: true
                }), scriptEl = _ref.script, needAttach = _ref.needAttach;
                needAttach && document.head.appendChild(scriptEl);
            });
        }
    }
}
//#endregion
exports.defaultPreloadArgs = defaultPreloadArgs;
exports.formatPreloadArgs = formatPreloadArgs;
exports.normalizePreloadExposes = normalizePreloadExposes;
exports.preloadAssets = preloadAssets; //# sourceMappingURL=preload.cjs.map
